var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/bin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/bin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,1 C15.6568542,1 17,2.34314575 17,4 L17,5 L21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L20,7 L20,20 C20,21.6568542 18.6568542,23 17,23 L7,23 C5.34314575,23 4,21.6568542 4,20 L4,7 L3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 L7,5 L7,4 C7,2.34314575 8.34314575,1 10,1 L14,1 Z M6,7 L6,20 C6,20.5522847 6.44771525,21 7,21 L17,21 C17.5522847,21 18,20.5522847 18,20 L18,7 L6,7 Z M14,3 L10,3 C9.44771525,3 9,3.44771525 9,4 L9,5 L15,5 L15,4 C15,3.44771525 14.5522847,3 14,3 Z",
    id: "Combined-Shape",
    fill: "#F12762",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.627845b18be87df65a1de7f60915d977.svg";
export { ForwardRef as ReactComponent };